module.exports = __webpack_public_path__ + "img/banner-alarm.e2e7bc78.png";